import React, {useState} from "react";
import { Link, NavLink } from "react-router-dom";
import {  useSelector , useDispatch} from "react-redux";
import {logout} from '../Features/userSlice'

export default function NavBar() {
  const isLogin = useSelector((state) => state.user.isLogin);
  const dispatch = useDispatch();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const logOutHandle = () => {
   dispatch(logout())
  }
  const links = [
    {
      name: "Home",
      value: "/",
    },
    {
      name: "Report",
      value: "/report",
    },
    {
      name: "Diet",
      value: "/diet",
    },
    {
      name: "Workout",
      value: "/workout",
    },
    {
      name: "Profile",
      value: "/profile",
    },
    
  ];
  return (
    // <nav className="  bg-gray-900">
    //   <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
    //     <Link
    //       to="/"
    //       className="flex items-center space-x-3 rtl:space-x-reverse"
    //     >
          
    //       <span className="self-center text-2xl font-semibold whitespace-nowrap  text-white">
    //         Gym Assistant
    //       </span>
    //     </Link>
    //     <button
    //       data-collapse-toggle="navbar-default"
    //       type="button"
    //       className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200  text-gray-400   "
    //       aria-controls="navbar-default"
    //       aria-expanded="false"
    //     >
    //       <span className="sr-only">Open main menu</span>
    //       <svg
    //         className="w-5 h-5"
    //         aria-hidden="true"
    //         xmlns="http://www.w3.org/2000/svg"
    //         fill="none"
    //         viewBox="0 0 17 14"
    //       >
    //         <path
    //           stroke="currentColor"
    //           stroke-linecap="round"
    //           stroke-linejoin="round"
    //           stroke-width="2"
    //           d="M1 1h15M1 7h15M1 13h15"
    //         />
    //       </svg>
    //     </button>
    //     <div className="hidden w-full md:block md:w-auto" id="navbar-default">
    //       <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border  rounded-lg  md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0  bg-gray-800 md:bg-gray-900  border-gray-700">
    //         {links.map((item, index) => (
    //           <li key={item.name}>
    //             <NavLink
    //               to={item.value}
    //               className={(isActive) =>
    //                 !isActive
    //                   ? `block py-2 px-3 bg-blue-700 rounded md:bg-transparent  md:p-0  text-white md:text-blue-500`
    //                   : `block py-2 px-3  rounded  md:border-0  text-white md:hover:text-blue-700 md:p-0   md:hover:text-blue-500  hover:bg-gray-700   md:hover:bg-transparent`
    //               }
    //             >
    //               {item.name}
    //             </NavLink>
    //           </li>
    //         ))}

    //         {isLogin && (
    //            <li>
    //           <button onClick={logOutHandle} className="block py-2 px-3  rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0  text-white md:hover:text-blue-700 md:p-0   md:hover:text-blue-500  hover:bg-gray-700   md:hover:bg-transparent">
    //             Logout
    //           </button>
    //           </li>
    //         )}

            
    //       </ul>
    //     </div>
    //   </div>
    // </nav>
    <nav className="bg-gray-900">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
        <Link to="/" className="flex items-center space-x-3 rtl:space-x-reverse">
          <span className="self-center text-2xl font-semibold whitespace-nowrap text-white">Gym Assistant</span>
        </Link>
        <button
          onClick={toggleMenu}
          className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-400 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
          aria-controls="navbar-default"
          aria-expanded={isMenuOpen ? "true" : "false"}
        >
          <span className="sr-only">Open main menu</span>
          <svg
            className="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 17 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M1 1h15M1 7h15M1 13h15"
            />
          </svg>
        </button>
        <div className={`w-full md:w-auto md:flex md:items-center ${isMenuOpen ? 'block' : 'hidden'}`} id="navbar-default">
          <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border rounded-lg md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 bg-gray-800 md:bg-gray-900 border-gray-700">
            {links.map((item, index) => (
              <li key={item.name}>
                <NavLink
                  to={item.value}
                  className={(isActive) =>
                    !isActive
                      ? `block py-2 px-3 bg-blue-700 rounded md:bg-transparent md:text-blue-500 md:p-0 text-white`
                      : `block py-2 px-3 rounded md:border-0 text-white md:hover:text-blue-700 md:p-0 md:hover:text-blue-500 hover:bg-gray-700 md:hover:bg-transparent`
                  }
                >
                  {item.name}
                </NavLink>
              </li>
            ))}
            {isLogin && (
              <li>
                <button onClick={logOutHandle} className="block py-2 px-3 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 text-white md:hover:text-blue-700 md:p-0 md:hover:text-blue-500 hover:bg-gray-700 md:hover:bg-transparent">
                  Logout
                </button>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}
